@if (!onlyArrow()) {
    @if (hasPoints()) {
        <div
            class="bazis-trip-line__point"
            part="start-point"
        ></div>
    }

    <div
        class="bazis-trip-line__line"
        part="line"
    ></div>

    @if (hasArrow()) {
        <div
            class="bazis-trip-line__arrow"
            part="arrow"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
            >
                <path
                    d="M10.811 18.707l-1.41-1.414L14.688 12 9.4 6.707l1.415-1.414 5.285 5.293a2 2 0 010 2.828l-5.289 5.293z"
                    fill="currentColor"
                />
            </svg>
        </div>
    }

    @if (sign()) {
        <div
            class="bazis-trip-line__sign"
            part="sign"
            >{{ sign() }}</div
        >
    }

    @if (!sign() && hasPoints()) {
        <div
            class="bazis-trip-line__point"
            part="end-point"
        ></div>
    }
} @else {
    <div class="bazis-trip-line__arrow">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
        >
            <path
                d="M10.811 18.707l-1.41-1.414L14.688 12 9.4 6.707l1.415-1.414 5.285 5.293a2 2 0 010 2.828l-5.289 5.293z"
                fill="currentColor"
            />
        </svg>
    </div>
}
